<template>
    <v-dialog v-model="dialog.show" persistent max-width="460">
        <v-card tile flat>
            <v-card-title class="headline">{{getLabel(dialog.action)}} esemény elutasítása</v-card-title>
            <v-card-text>
                Kérem válassza ki, milyen okból találja kifogásolhatónak a jegyzőkönyvvezető által felvett eseményt!
                <br /><br />

                <v-card-actions class="d-flex flex-column pa-0 ma-0 transparent" width="100%">
                    <RejectReasonButton reason="player" :reasons="rejectReasons" :selected="dialog.reason"/>
                    <RejectReasonButton reason="event" :reasons="rejectReasons" :selected="dialog.reason"/>
                    <RejectReasonButton reason="time" :reasons="rejectReasons" :selected="dialog.reason"/>
                    <RejectReasonButton reason="missclick" :reasons="rejectReasons" :selected="dialog.reason"/>
                </v-card-actions>

                <v-textarea
                    v-model="dialog.message"
                    name="missing-message"
                    label="Üzenet (nem kötelező)"
                ></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn depressed tile @click="close">Mégsem</v-btn>
                <v-btn depressed tile color="green" @click="save" :disabled="!dialog.reason">Mentés</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import RejectReasonButton from "@/components/dmr/RejectReasonButton";
    import CONSTANTS from "@/constants";
    import eventBus from '@/eventBus';

    import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
        name: 'RejectDialog',
        components: {
            RejectReasonButton
        },
        props: {
            getLabel: Function,
            rejectReasons: Object,
        },
        data: function () {
            return {
                dialog: {
                    show: false,
                    UUID: null,
                    reason: null,
                    action: null,
                    message: null
                }
            }
        },
        created() {
            let self = this;

            this.$busOn(CONSTANTS.DMR.REJECT_MODAL, function (item) {
                self.dialog = {
                    show: true,
                    UUID: item.UUID,
                    reason: null,
                    action: item.action,
                    message: item.message
                }
            });

            this.$busOn(CONSTANTS.DMR.SELECT_REJECT_REASON, function (reason) {
                self.dialog.reason = reason;
            });
        },
        methods: {
            close: function () {
                this.dialog = {
                    show: false,
                    UUID: null,
                    reason: null,
                    action: null,
                    message: null
                }
            },
            save: function () {
                let self = this;

                eventBus.$emit(CONSTANTS.DMR.REJECT, {
                    UUID: self.dialog.UUID,
                    rejectReason: self.dialog.reason,
                    message: self.dialog.message
                });

                self.close();
            },
        }
    }
</script>
